<template>
    <div class="cB">
        <div class="outer">
            <div class="main" v-for="(item, index) in defaultdata" :key="index">
                <div class="m-item ">
                    <p class="title">{{ item.value1 }}</p>
                    <div class="progress-bar">
                        <div class="bar" :style="{left: (+item.value2 / maxnum * 100) + '%'}"></div>
                        <div class="progress" :style="{width: (+item.value2 / maxnum * 100) + '%'}"></div>
                    </div>
                    <span class="num">{{ item.value2 }}</span>
                    <span class="unit">{{ item.value3 }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as methods from './method.js'
export default {
    name: 'template.scope7',
	props: {
		vdata: {
			type: [Array, String],
			default: () => []
		},
		jsondata: {
			type: [Array, String],
			default: () => []
		},
		scopedata: {
			type: Object,
			default: () => {}
		}
	},
    data() {
        return {
            defaultdata: [
                { value1: "系列一", value2: '255', value3: "所" },
                { value1: "系列二", value2: '2560', value3: "人" },
                { value1: "系列三", value2: '5520', value3: "人" },
            ],
            valueMap: [
                { name: '名称', key: "value1" },
                { name: '数值', key: "value2" },
                { name: '单位', key: "value3" },
            ],
			exceldata: [],
			apiconfig: {},
			isApi: false,
			scope: {},
            isExcel: false
        }
    },
    computed: {
        maxnum() {
            let max = 0
            max = Math.max(...this.defaultdata.map(item => +item.value2))
            return max
        }
    },
    mounted() {
        if (this.vdata && this.vdata.length) {
			this.defaultdata = this.vdata
		}
		if (this.jsondata && this.jsondata.length) {
			this.exceldata = this.jsondata
		}
        this.setData()
    },
    watch: {
        vdata(n) {
			if(n && n.length) {
				this.defaultdata = n
			}
		},
		jsondata(n) {
			this.exceldata = n
		}
    },
    methods: {
		...methods,
    },
    beforeDestroy() {

    },
}
</script>

<style scoped lang="scss">
@font-face {
    font-family: "YeJinShuZi";
    src: url("../../assets/fonts/YeJinShuZi.woff2");
}

.cB {
    width: 435px;
    height: 240px;

    padding: 10px 0;
}

.outer {
    width: 435px;
    height: 240px;
    position: relative;

    z-index: 1;
}

.main {
    width: 360px;
    margin: 16px auto;
   

}

.m-item {
    position: relative;
    margin:20px 0 40px;
    // padding: 12px 0 0 10px;
    .title {

        font-family: Source Han Sans CN;
        // font-weight: 400;
        font-size: 14px;
        color: #e3e4e6;
        margin-bottom: 6px;
        position: relative;

    }

    .title::after {
        content: "";
        width: 18px;
        height: 18px;
        background: url('../../assets/template3/sanjiao.png') no-repeat;
        background-size: 100% 100%;
        position: absolute;
        left: -20px;
        top: 0px;

    }

    .num {

        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        margin: 0 4px 0 0;
        position: absolute;
        right: 30px;
        top: 0;

    }

    .unit {
        width: 24px;
        height: 11px;
        // font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 12px;
        color: #CBCBCB;
        position: absolute;
        right: 0;
        top: 0;
    }
}

.progress-bar {
    width: 360px;
    background: #26303D;
    border-radius: 4px;
    overflow: hidden;
}

.progress {
    background: #35D2D1;
    background: linear-gradient(90deg, #26303D, #35D2D1 60%);
    height: 6px;
    border-radius: 4px;
    position: relative;
    transition: width 0.5s ease;
}

.bar {
    content: "";
    width: 8px;
    height: 8px;
    background: #fff;
    border-radius: 50%;
    position: absolute;
    top: 25px;
    // left: 105px;
    z-index: 10;
}

.bar::before {
    content: "";
    width: 12px;
    height: 12px;
    border-radius: 50%;
    position: absolute;
    top: -4px;
    left: -4px;
    z-index: 10;
    border: 2px solid #234451;
}

/* 可选: 为进度条添加动画效果 */
.progress.animate {
    width: 100%;
    animation: progress-bar-stripes 2s linear infinite;
}

@keyframes progress-bar-stripes {
    from {
        background-size: 40px 40px;
    }

    to {
        background-size: 40px 0;
    }
}
</style>